import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { Input } from '../../../../web/components-v2/Input';
import { composerStyles as styles } from './composerStyles';

export interface LinkPopoverState {
	x: number;
	y: number;
}

interface ComposerLinkPopoverProps {
	position: LinkPopoverState;
	onApply: (url: string) => void;
	onDismiss: () => void;
}

/** Caret-adjacent link input: Enter or Apply commits, Escape dismisses. */
export const ComposerLinkPopover = React.forwardRef<HTMLDivElement, ComposerLinkPopoverProps>(
	({ position, onApply, onDismiss }, ref) => {
		const [url, setUrl] = React.useState('');

		const handleKeyDown = (event: React.KeyboardEvent) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				onApply(url);
			}
			if (event.key === 'Escape') onDismiss();
		};

		return (
			<div ref={ref} className={css(styles.linkPopover)} style={{ left: position.x, top: position.y }}>
				<Input
					type='text'
					styles={[styles.linkInput]}
					placeholder='Paste or type a link…'
					value={url}
					onChange={event => setUrl(event.target.value)}
					onKeyDown={handleKeyDown}
					autoFocus
				/>
				<Button variant='primary' size='sm' styles={[styles.linkApplyBtn]} onClick={() => onApply(url)}>
					Apply
				</Button>
			</div>
		);
	}
);

ComposerLinkPopover.displayName = 'ComposerLinkPopover';
